import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useIncomeSummaryModel } from "../incomeSummaryModel";
import { IIncomeSummaryDetail } from "../incomeSummaryService";
import { formatNum, momentFormat } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";

export function CostTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useIncomeSummaryModel();
    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        loadData();
    }, [])

    const columns: ColumnsType<IIncomeSummaryDetail> = [
        {
            title: '月份',
            width: 80,
            align: "center",
            dataIndex: 'day',
            render: (t, r, i) => t !== "13" ? t + "月" : "总计",

        }, {
            title: '纯销售配件成本(XS)',
            width: 140,
            dataIndex: 'saleTotalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '销售毛利率',
            width: 140,
            align: "center",
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '服务销售配件成本(WO)',
            width: 140,
            align: "center",
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '维修毛利率',
            width: 140,
            align: "center",
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '合计',
            width: 140,
            align: "center",
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }
    ];
    return (
        <Table
            bordered
            rowKey={record => record.id}
            columns={columns}
            dataSource={[]}
            pagination={false}
            scroll={{ x: 'max-content', y: "calc(100vh - 452px)" }
            }
        />
    )
}